<app-page-detail [id]="id" [crud]="service" [(model)]="model" [(form)]="form" [reload]="reload" (modelChange)="changeModelSelect()">
  <form *ngIf="form" [formGroup]="form" >
  <div class="grid m-0">
    <div class="col-12" style="text-align:center;margin-top:20px">
      <span class="text-lg  font-normal mt-2">Dettaglio</span>
    </div>
    <div class="col-12">
      <app-editable-card>
        <div class="grid m-0">
<!--           <div class="col-12" style="margin-top:20px;margin-bottom:20px;text-align: center;"><span class="text-lg font-normal mt-2" >Anagrafica</span></div> -->
          <div class="col-12 md:col-6 lg:col-6 flex justify-content-center">
            <app-text-field label="Username:" [value]="model()?.username ?? '---'"></app-text-field>
          </div>
          <div class="col-12 md:col-6 lg:col-6 flex justify-content-center">
            <app-text-field label="Email:" [value]="model()?.email ?? '---'"></app-text-field>
          </div>
         <!-- <div class="col-12 md:col-12 lg:col-12">
            <div style="margin-top:20px;margin-bottom:20px;text-align: center;"><span class="text-lg font-normal mt-2" >Ruoli</span></div>
            <mat-form-field *ngIf="ruoli">
              <mat-label>Lista dei ruoli</mat-label>
              <mat-select 
          
              formControlName="ruoli" 
                [(ngModel)]="selectedRoles" 
                (ngModelChange)="selectedRoles"
                 multiple>
             
                  <mat-option *ngFor="let ruolo of ruoli" [value]="ruolo.name">
                    {{ruolo.name}}
                  </mat-option>
                
    
              </mat-select>
            </mat-form-field>

          </div>-->
          <div class="col-12 md:col-12 lg:col-12">
          <br>
            <mat-divider class="mx-3"></mat-divider>
            <br><br>
          </div>
          <div class="col-3 md:col-3 lg:col-3 flex gap-1" >
            <button mat-raised-button color="primary" [disabled]="viewMatSpinner" (click)="showDialog()">
              <mat-icon  class="material-symbols-outlined" *ngIf="!viewMatSpinner" >add</mat-icon>
              <mat-icon *ngIf="viewMatSpinner"><mat-spinner color="accent" diameter="20" ></mat-spinner></mat-icon>  
              <span >Aggiungi un nuovo Ruolo</span>
             </button>           
          </div>
       
         <div class="col-12 md:col-12 lg:col-12" *ngIf="generalComuni().length>0 && generalRegioni().length>0 && checkCaricamentoLuoghi">
 
           <ng-container *ngFor="let ruoloSelected of selectedRoles">
            <div class="flex flex-column gap-1">
              <div class="flex gap-1 justify-content-between">
                <div class="flex gap-1 px-2">
                 <!--  <div class="text-sm text-700 ">{{ruoloSelected}}</div> -->
                </div>
                <div class="px-1 text-sm">
                  <ng-content select="[actions]"></ng-content>
                </div>
              </div>
              <div [class]="'flex flex-column gap-1 border-round border-1 surface-border bg-white p-2' "  style="overflow-x: scroll;">
                <div style="margin-top:20px; margin-bottom:20px; display:flex; justify-content:space-between; align-items: center;">
                  <span class="text-lg font-normal mt-2">{{ruoloSelected}}</span>
                  <div class="flex gap-2 button-container">
                    <app-button label="Salva" outlined fullWidth icon="save" color="primary" (click)="onSave(updateUserArray[ruoloSelected!])"></app-button>
                    <app-button label="Elimina" outlined fullWidth icon="delete" color="warn" (click)="onDelete()"></app-button>
                  </div>
                </div>
                
 
              <app-input-group-luogo-area 
              [form]="updateUserArray[ruoloSelected!]" 
              [generalRegioni]="generalRegioni" 
              [generalComuni]="generalComuni" 
              [selectedUserEnabledLocation]="selectedUserEnabledLocation[ruoloSelected]"
              [delegheRegioni]="delegheRegioni"
              [delegheComuni]="delegheComuni">
              </app-input-group-luogo-area>
            </div>
          </div>
          <br>
            </ng-container>
      
         
            </div> 
  
         
        </div>
      </app-editable-card>
    </div>

  </div>
</form>
</app-page-detail>


